"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var ModalHeader = function () {
    return (react_1["default"].createElement(box_1["default"], { padding: "8px 3px" },
        react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold" }, "Configure Button Text in Other Languages")));
};
exports["default"] = ModalHeader;
